import { render, staticRenderFns } from "./RemodelationsForm.vue?vue&type=template&id=419a8163&"
import script from "./RemodelationsForm.vue?vue&type=script&lang=js&"
export * from "./RemodelationsForm.vue?vue&type=script&lang=js&"
import style0 from "./RemodelationsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports